export class GetDealsRequestModel {
    displayOnlyUncanceled: boolean;
    startDate: Date;
    endDate: Date;
    userId: number;
}


// WEBPACK FOOTER //
// ./src/app/_models/requests/get-deals-request.model.ts